module.exports = __webpack_public_path__ + "img/slider-under-2.8ef67a0a.png";